import { render, staticRenderFns } from "./search-new.vue?vue&type=template&id=e277a4d4&scoped=true"
import script from "./search-new.vue?vue&type=script&lang=js"
export * from "./search-new.vue?vue&type=script&lang=js"
import style0 from "./search-new.vue?vue&type=style&index=0&id=e277a4d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e277a4d4",
  null
  
)

export default component.exports